import { render, staticRenderFns } from "./SlipperyRatingDanish.vue?vue&type=template&id=5def0ead"
import script from "./SlipperyRatingDanish.vue?vue&type=script&lang=js"
export * from "./SlipperyRatingDanish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports